import type { ReactNode } from 'react'

import type { Clinic } from '@snootsvet/shared/portal'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemContent,
  SelectItemDescription,
  SelectItemLabel,
  SelectTrigger,
  SelectValue,
} from '@/customer/components/ui/select'

function ClinicRow({ clinic, accessory }: { clinic: Clinic; accessory?: ReactNode }) {
  return (
    <>
      <SelectItemContent>
        <SelectItemLabel className="font-bold">{clinic.name}</SelectItemLabel>
        <SelectItemDescription className="truncate text-fine-print">
          {clinic.address}
        </SelectItemDescription>
      </SelectItemContent>
      {accessory ? <span className="shrink-0 self-center">{accessory}</span> : null}
    </>
  )
}

/** Select-flavoured clinic chooser with an optional per-clinic accessory. */
export function ClinicSelect({
  value,
  onValueChange,
  clinics,
  accessory,
  placeholder = 'Choose a clinic',
  disabled,
  id,
}: {
  value: string | null
  onValueChange: (id: string | null) => void
  clinics: Clinic[]
  accessory?: (clinic: Clinic) => ReactNode
  placeholder?: string
  disabled?: boolean
  id?: string
}) {
  return (
    <Select
      value={value}
      disabled={disabled}
      onValueChange={onValueChange}
      items={clinics.map((clinic) => ({ value: clinic.id, label: clinic.name }))}
    >
      <SelectTrigger id={id}>
        <SelectValue
          className="font-bold data-placeholder:font-normal data-placeholder:italic data-placeholder:text-muted-foreground"
          placeholder={placeholder}
        />
      </SelectTrigger>
      <SelectContent>
        {clinics.map((clinic) => (
          <SelectItem key={clinic.id} value={clinic.id}>
            <ClinicRow clinic={clinic} accessory={accessory?.(clinic)} />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
